import { ChangeEvent, ReactNode, useMemo, useRef, useEffect } from 'react';

import { HiddenInput, LabelContainer } from './styles';
interface IUploadFileWrapperProps {
  children?: ReactNode;
  acceptedFileTypes?: ('video' | 'image' | 'document' | 'pdf' | string)[];
  disabled?: boolean;
  multiple?: boolean;
  value?: FileList | null;
  width?: number | string;
  maxFileSize?: number;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onFileSizeError?: (fileSize: number, maxSize: number) => void;
}

export function UploadFileWrapper({
  children,
  acceptedFileTypes = [],
  disabled,
  multiple = true,
  value,
  width,
  onChange,
}: IUploadFileWrapperProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current && value === null) {
      inputRef.current.value = '';
    }
  }, [value]);

  const accept = useMemo(() => {
    if (acceptedFileTypes.length === 0) return undefined;

    const typeMap: Record<string, string> = {
      image: 'image/*',
      video: 'video/*',
      document: '.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf',
      pdf: '.pdf',
    };

    return acceptedFileTypes
      .map((fileType) => typeMap[fileType] ?? fileType)
      .filter(Boolean)
      .join(',');
  }, [acceptedFileTypes]);

  return (
    <LabelContainer $width={width}>
      <HiddenInput
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={onChange}
        multiple={multiple}
        disabled={disabled}
      />
      {children}
    </LabelContainer>
  );
}
